import { render, staticRenderFns } from "./ImprintView.vue?vue&type=template&id=4e548bf6"
import script from "./ImprintView.vue?vue&type=script&lang=js"
export * from "./ImprintView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports